export default "__VITE_ASSET__5a0wH8IS__"